export class AccountAlreadyVerified extends Error {
  constructor(readonly userId: string) {
    super('This account has already been verified.')
    Object.setPrototypeOf(this, AccountAlreadyVerified.prototype)
  }
}
